import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../Containers/Config/index.js';
import { GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2, GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_SUCCESS, GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_ERROR } from '../actions.js';
import apiCall from '../../apiCall.js';

function* getDownloadDumpAdminCustomerV2({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/client/downloads`,
      method: 'GET',
      params: payload?.urlParams,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_ERROR, payload: error });
  }
}

export function* watchDownloadDumpDumpAdminCustomerV2() {
  yield takeEvery(GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2, getDownloadDumpAdminCustomerV2);
}

function* getDownlaodDumpListCustomerSaga() {
  yield all([fork(watchDownloadDumpDumpAdminCustomerV2)]);
}

export default getDownlaodDumpListCustomerSaga;
